import { useId, useState } from 'react'
import { Icon } from '../components/Icon'
import { FieldRenderer } from '../components/FieldRenderer'
import { Modal } from '../components/Modal'
import type { FieldDef } from '../domain/types'

// Modal de campos de transição (Fase 5b): coleta os campos customizados de uma ação
// (ex.: OnComplete) antes de concluí-la. Reaproveita o padrão de CancelModal/TransferModal.
export function TransitionFieldsModal({ title, fields, submitting, onClose, onConfirm }: {
  title: string
  fields: FieldDef[]
  submitting: boolean
  onClose: () => void
  onConfirm: (values: Record<string, string>) => void
}) {
  const titleId = useId()
  const [values, setValues] = useState<Record<string, string>>({})
  const valid = fields.every((f) => !f.required || (values[f.key] || '').trim() !== '')

  return (
    <Modal open onClose={submitting ? () => {} : onClose} titleId={titleId} title={title} closeOnOverlay={!submitting}>
      <div>
        <div className="fz-modal__icon"><Icon name="check" size={24} /></div>
        <div className="fz-modal__title" id={titleId}>{title}</div>
        <div className="fz-modal__text">Preencha os campos abaixo para concluir o atendimento.</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, textAlign: 'left' }}>
          {fields.map((f, i) => (
            <FieldRenderer
              key={f.key}
              def={f}
              autoFocus={i === 0}
              value={values[f.key] || ''}
              onChange={(v) => setValues((prev) => ({ ...prev, [f.key]: v }))}
            />
          ))}
        </div>
        <div className="fz-modal__actions">
          <button className="fz-btn fz-btn--neutral fz-btn--block" onClick={onClose} disabled={submitting}>Cancelar</button>
          <button className="fz-btn fz-btn--primary fz-btn--block" disabled={!valid || submitting} onClick={() => onConfirm(values)}>
            {submitting ? 'Concluindo…' : 'Confirmar conclusão'}
          </button>
        </div>
      </div>
    </Modal>
  )
}